/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_DriftingInputs */

const en_ui_more_stats_drifting = /** @type {(inputs: Ui_More_Stats_DriftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drifting`)
};

const de_ui_more_stats_drifting = /** @type {(inputs: Ui_More_Stats_DriftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driftet`)
};

/**
* | output |
* | --- |
* | "Drifting" |
*
* @param {Ui_More_Stats_DriftingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_drifting = /** @type {((inputs?: Ui_More_Stats_DriftingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_DriftingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_drifting(inputs)
	return de_ui_more_stats_drifting(inputs)
});